import { Component } from '@verndale/core';

class Module extends Component {
    setupDefaults() {
        this.elementToSkip = document.querySelector(`.${this.el.getAttribute('data-element-to-scroll-selector')}`);
        this.elementScrollTo = this.elementToSkip.nextElementSibling;
    }

    calculateScroll() {
        const $header = document.querySelector('.header');
        $header.classList.add('fixed');
        return this.elementScrollTo.offsetTop -  $header.offsetHeight;
    }

    addListeners() {
        this.el.addEventListener('click', this.scrollToContent.bind(this));
    }

    scrollToContent() {
        this.elementScrollTo.setAttribute('tabindex', '-1');            
        this.elementScrollTo.focus();
        window.scrollTo({
            top: this.calculateScroll(),
            behavior: 'smooth',
        })
    }
}
export default Module;